import { getToken, removeToken } from './auth';
import { config } from '../config';

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  data?: any;
  headers?: Record<string, string>;
}

/**
 * 统一请求封装
 * 自动注入 access_token header
 */
export const request = async <T>(
  endpoint: string,
  options: RequestOptions = {}
): Promise<T> => {
  const { method = 'GET', data, headers = {} } = options;

  // 获取 token
  const token = getToken();

  // 构建完整 URL
  const url = endpoint.startsWith('http') ? endpoint : `${config.API_BASE}${endpoint}`;

  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'access_token': token } : {}),
      ...headers,
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  // 401 未授权，清除 token
  if (response.status === 401) {
    removeToken();
    throw new Error('Unauthorized');
  }

  const result = await response.json();

  // 检查响应码
  if (result.code === 200 || result.code === 200) {
    return result.data || result;
  }

  throw new Error(result.message || 'Request failed');
};

/**
 * 获取登录链接（请求后端，返回 302 重定向地址）
 */
export const getLoginUrl = async (): Promise<string> => {
  const response = await fetch(`${config.API_BASE}${config.CASDOOR_URL}`, {
    method: 'GET',
    redirect: 'manual',
  });

  if (response.status === 302) {
    const location = response.headers.get('Location');
    if (location) {
      return location;
    }
  }

  throw new Error('Failed to get login URL');
};
